/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deleteTag} from '../api'

export const useMutationDeleteTag = createReactQueryMutationHook('deleteTag', deleteTag)
